import React, { useState, useEffect } from 'react';
// --- FIX: CHANGED BrowserRouter TO HashRouter ---
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom'; 

import Navbar from './components/Navbar';
import LoansTable from './components/LoansTable';
import SkillsTable from './components/SkillsTable';
import WorkshopsTable from './components/WorkshopsTable';
import UsersTable from './components/UsersTable';
import Login from './components/Login';
import ExhibitionsTable from './components/ExhibitionsTable';
import SliderManager from './components/SliderManager';
import DmsUserManagement from './components/DmsUserManagement';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const loggedIn = localStorage.getItem('isAdminLoggedIn');
    if (loggedIn === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = () => setIsAuthenticated(true);
  const handleLogout = () => {
    localStorage.removeItem('isAdminLoggedIn');
    setIsAuthenticated(false);
  };

  return (
    // Because we alias HashRouter as Router, the rest of your code stays EXACTLY the same!
    <Router>
      <div className="App">
        {isAuthenticated && <Navbar onLogout={handleLogout} />}
        <Routes>
          {!isAuthenticated ? (
            <Route path="*" element={<Login onLogin={handleLogin} />} />
          ) : (
            <>
              <Route path="/" element={<Navigate to="/exhibitions" />} />
              <Route path="/loans" element={<LoansTable />} />
              <Route path="/skills" element={<SkillsTable />} />
              <Route path="/workshops" element={<WorkshopsTable />} />
              <Route path="/exhibitions" element={<ExhibitionsTable />} />
              
              <Route path="/sliders" element={<SliderManager />} />
              <Route path="/users" element={<UsersTable />} />
              <Route path="/dms-users" element={<DmsUserManagement />} />
            </>
          )}
        </Routes>
      </div>
    </Router>
  );
}

export default App;